import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { AcceptedTbTestTypes } from "./components/AcceptedTbTestTypes";
import { TbTestChecklist } from "./components/Checklist";

export function TbTestGuidedUploadInstructions() {
  return (
    <>
      <Stack spacing={3}>
        <Text bold variant="body2" sx={{ color: (theme) => theme.palette.text.secondary }}>
          Your document should include
        </Text>

        <TbTestChecklist />
      </Stack>

      <Stack spacing={3}>
        <Text bold variant="body2" sx={{ color: (theme) => theme.palette.text.secondary }}>
          You may satisfy with one of these tests
        </Text>

        <AcceptedTbTestTypes />
      </Stack>
    </>
  );
}
